/*
Base application controller
*/
import { Controller } from "@hotwired/stimulus";
//import { debug } from '../utils/logger';

export default class extends Controller {
  initialize() {
    /*
            Creates a document-scoped variable with the same name as the controller. 
            Allowing other controllers to call methods on this controller like so:
            element.controllerName.method()
        */
    this.element[this.identifier] = this;
  }

  connect() {
    //debug(`Hello, Stimulus! ${this.identifier}`);
  }
}
